"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const useInfoBoxStateReducer_1 = require("../../hooks/useInfoBoxStateReducer");
const analytics_1 = require("@completeanatomy/analytics");
const ui_1 = require("@completeanatomy/ui");
function TitleMobile({ title, altTitle, withAudio, playing = false, }) {
    const bridge = (0, bridge_1.useBridge)();
    const [{ isExpanded }, dispatch] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const analytics = (0, analytics_1.useAnalytics)();
    const onPlay = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.playSelectedInfoBoxObjectAudio();
        analytics.log('InfoBoxAudioPlayed');
    };
    const onClose = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.infoBoxCloseAction();
        dispatch((0, useInfoBoxStateReducer_1.expandMenu)(true));
    };
    const onExpand = () => {
        dispatch((0, useInfoBoxStateReducer_1.expandMenu)(!isExpanded));
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'TitleMobile_Container', children: [(0, jsx_runtime_1.jsxs)(TopLine, { "data-e2e": 'TitleMobile_TopLine', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'TitleMobile_Title', children: title }), withAudio && ((0, jsx_runtime_1.jsx)(PlayButton, { "$playing": playing, onClick: onPlay, "aria-pressed": playing, "data-e2e": 'TitleMobile_PlayButton', children: (0, jsx_runtime_1.jsx)(PlayIcon, { name: ui_1.Icons.Sound, selected: playing, "data-e2e": 'TitleMobile_PlayIcon' }) })), (0, jsx_runtime_1.jsx)(ExpandButton, { onClick: onExpand, "data-e2e": 'TitleMobile_ExpandButton', children: (0, jsx_runtime_1.jsx)(ExpandIcon, { "$expanded": isExpanded, name: ui_1.Icons.Arrow_Down, "data-e2e": 'TitleMobile_ExpandIcon' }) }), (0, jsx_runtime_1.jsx)(CloseIcon, { role: "button", "aria-label": "Close", onClick: onClose, "data-e2e": 'TitleMobile_CloseIcon' })] }), altTitle && (0, jsx_runtime_1.jsx)(AltTitle, { "data-e2e": 'TitleMobile_AltTitle', children: altTitle })] }));
}
exports.TitleMobile = TitleMobile;
const Container = styled_components_1.default.div `
  box-sizing: border-box;
  width: 100%;
  padding: 12px;

  user-select: none;
`;
const TopLine = styled_components_1.default.div `
  display: flex;
  flex-flow: row nowrap;
`;
const Title = styled_components_1.default.div `
  margin-right: auto;

  font-weight: bold;
  font-size: 20px;
  line-height: 22px;
`;
const AltTitle = styled_components_1.default.div `
  margin-top: 2px;
  margin-right: 80px;

  font-size: 14px;
`;
const ExpandButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  align-items: center;

  width: 30px;
  height: 30px;

  margin: 0;
  padding: 0;
`;
const ExpandIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 25px;
  height: 25px;

  color: ${({ theme }) => theme.textSecondary};

  transform: scale(${({ $expanded }) => ($expanded ? 1 : -1)});
`;
const CloseIcon = styled_components_1.default.div `
  position: relative;

  width: 24px;
  height: 24px;

  &::before,
  &::after {
    position: absolute;
    top: 2px;
    left: 18.5px;

    width: 2px;
    height: 22px;

    background: ${({ theme }) => theme.textSecondary};
    transform: rotate(45deg);

    content: '';
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
const PlayButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  align-items: center;

  width: 30px;
  height: 24px;

  margin: 0 10px;
  padding: 0;

  color: ${({ $playing, theme }) => $playing ? theme.text : theme.textSecondary};
`;
const PlayIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 20px;
`;
